import React, {Component} from "react";
import {
    Backdrop,
    CircularProgress,
} from "@mui/material";
import {
    VinDecoder,
    SectionsTable,
    ItemsTable,
    DialogSectionForm,
    DialogItemForm,
} from "./components";
import {
    DialogConfirmation
} from "../../../components";
import {
    Notification,
    notificationTypes
} from "../../../common/Notification";
import agent from "../../../agent/agent";

class DirectoryVin extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sections: [],
            expandedSectionId: null,

            isLoading: true,
            isBackdrop: false,
        };
        this.refDialogSectionForm = React.createRef();
        this.refDialogItemForm = React.createRef();
        this.refDialogConfirmation = React.createRef();
    }

    componentDidMount = async () => {
        await this.getSections();
    }

    // ==================
    // SECTIONS
    // ==================
    getSections = async () => {
        this.setState({isLoading: true});
        const res = await agent.get("/vin-dictionary/sections")
            .then((res) => res.data?.sections)
            .catch(() => ({}));

        const list = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
        list.sort((a, b) => (a.position_from || 0) - (b.position_from || 0));
        this.setState({
            sections: list,
            isLoading: false,
        });
    }
    expandSection = (sectionId) => {
        this.setState((prev) => ({
            expandedSectionId: prev.expandedSectionId === sectionId ? null : sectionId,
        }));
    }
    openCreateSection = () => {
        this.refDialogSectionForm.current.open({
            item: null,
            onSubmit: this.createSection,
        });
    }
    createSection = async (item) => {
        this.setState({isBackdrop: true});
        const res = await agent.post("/vin-dictionary/sections", {
            title: item.title,
            position_from: Number(item.position_from),
            position_to: Number(item.position_to),
            scheme: item.scheme,

        }).then((res) => res.data).catch((err) => ({error: err.response}));

        if (res?.error) {
            this.setState({isBackdrop: false});
            Notification({type: notificationTypes.error, message: "Ошибка создания раздела"});
            return;
        }

        this.refDialogSectionForm.current.close();
        await this.getSections();
        this.setState({isBackdrop: false});
        Notification({type: notificationTypes.success, message: "Раздел создан"});
    }
    openEditSection = (section) => {
        this.refDialogSectionForm.current.open({
            item: {...section},
            onSubmit: this.updateSection,
        });
    }
    updateSection = async (item) => {
        this.setState({isBackdrop: true});
        const res = await agent.put(`/vin-dictionary/sections/${item.id}`, {
            title: item.title,
            position_from: Number(item.position_from),
            position_to: Number(item.position_to),
            scheme: item.scheme,

        }).then((res) => res.data).catch((err) => ({error: err.response}));

        if (res?.error) {
            this.setState({isBackdrop: false});
            Notification({type: notificationTypes.error, message: "Ошибка обновления раздела"});
            return;
        }

        this.refDialogSectionForm.current.close();
        await this.getSections();
        this.setState({isBackdrop: false});
        Notification({type: notificationTypes.success, message: "Раздел обновлён"});
    }
    deleteSection = (section) => {
        this.refDialogConfirmation.current.onOpen({
            title: "Подтверждение",
            message: `Вы действительно хотите удалить раздел "${section.title}"? Все элементы раздела также будут удалены.`,
            acceptButtonTitle: "Да, удалить",
            acceptButtonAction: this.confirmDeleteSection.bind(this, section),
        });
    }
    confirmDeleteSection = async (section) => {
        this.setState({isBackdrop: true});
        const res = await agent.delete(`/vin-dictionary/sections/${section.id}`)
            .then((res) => res.data)
            .catch(() => ({error: true}));

        if (res?.error) {
            this.setState({isBackdrop: false});
            Notification({type: notificationTypes.error, message: "Ошибка удаления раздела"});
            return;
        }

        await this.getSections();
        this.setState({
            isBackdrop: false,
            expandedSectionId: this.state.expandedSectionId === section.id ? null : this.state.expandedSectionId,
        });
        Notification({type: notificationTypes.success, message: "Раздел удалён"});
    }

    // ==================
    // ITEMS
    // ==================
    getExpandedSection = () => {
        const {sections, expandedSectionId} = this.state;
        return (sections || []).find((s) => s.id === expandedSectionId) || null;
    }
    openCreateItem = () => {
        this.refDialogItemForm.current.open({
            item: null,
            onSubmit: this.createItem,
        });
    }
    createItem = async (item) => {
        const {expandedSectionId} = this.state;
        this.setState({isBackdrop: true});

        const body = {
            code: item.code,
            meaning: item.meaning,

        };
        if (item.year_from) body.year_from = Number(item.year_from);
        if (item.year_to) body.year_to = Number(item.year_to);

        const res = await agent.post(`/vin-dictionary/sections/${expandedSectionId}/items`, body)
            .then((res) => res.data)
            .catch((err) => ({error: err.response}));

        if (res?.error) {
            this.setState({isBackdrop: false});
            Notification({type: notificationTypes.error, message: "Ошибка создания элемента"});
            return;
        }

        this.refDialogItemForm.current.close();
        await this.getSections();
        this.setState({isBackdrop: false});
        Notification({type: notificationTypes.success, message: "Элемент создан"});
    }
    openEditItem = (item) => {
        this.refDialogItemForm.current.open({
            item: {...item},
            onSubmit: this.updateItem,
        });
    }
    updateItem = async (item) => {
        this.setState({isBackdrop: true});

        const body = {
            code: item.code,
            meaning: item.meaning,

        };
        if (item.year_from) body.year_from = Number(item.year_from);
        if (item.year_to) body.year_to = Number(item.year_to);

        const res = await agent.put(`/vin-dictionary/items/${item.id}`, body)
            .then((res) => res.data)
            .catch((err) => ({error: err.response}));

        if (res?.error) {
            this.setState({isBackdrop: false});
            Notification({type: notificationTypes.error, message: "Ошибка обновления элемента"});
            return;
        }

        this.refDialogItemForm.current.close();
        await this.getSections();
        this.setState({isBackdrop: false});
        Notification({type: notificationTypes.success, message: "Элемент обновлён"});
    }
    deleteItem = (item) => {
        this.refDialogConfirmation.current.onOpen({
            title: "Подтверждение",
            message: `Вы действительно хотите удалить элемент "${item.code} — ${item.meaning}"?`,
            acceptButtonTitle: "Да, удалить",
            acceptButtonAction: this.confirmDeleteItem.bind(this, item),
        });
    }
    confirmDeleteItem = async (item) => {
        this.setState({isBackdrop: true});
        const res = await agent.delete(`/vin-dictionary/items/${item.id}`)
            .then((res) => res.data)
            .catch(() => ({error: true}));

        if (res?.error) {
            this.setState({isBackdrop: false});
            Notification({type: notificationTypes.error, message: "Ошибка удаления элемента"});
            return;
        }

        await this.getSections();
        this.setState({isBackdrop: false});
        Notification({type: notificationTypes.success, message: "Элемент удалён"});
    }

    render() {
        const {
            sections,
            expandedSectionId,
            isLoading,
            isBackdrop,
        } = this.state;

        const expandedSection = this.getExpandedSection();

        return (
            <>
                <VinDecoder/>

                <SectionsTable
                    sections={sections}
                    isLoading={isLoading}
                    expandedSectionId={expandedSectionId}
                    onExpandSection={this.expandSection}
                    onCreateSection={this.openCreateSection}
                    onEditSection={this.openEditSection}
                    onDeleteSection={this.deleteSection}
                />

                {expandedSection && (
                    <ItemsTable
                        section={expandedSection}
                        items={expandedSection.items || []}
                        onCreateItem={this.openCreateItem}
                        onEditItem={this.openEditItem}
                        onDeleteItem={this.deleteItem}
                    />
                )}

                <Backdrop open={isBackdrop} sx={{zIndex: 9999}}>
                    <CircularProgress/>
                </Backdrop>
                <DialogSectionForm ref={this.refDialogSectionForm}/>
                <DialogItemForm ref={this.refDialogItemForm}/>
                <DialogConfirmation ref={this.refDialogConfirmation}/>
            </>
        );
    }
}

export default DirectoryVin;
